const el = {
  login: `Σύνδεση`,
  general: {
    delete_success: `Επιτυχής διαγραφή!`,
  },
  form: {
    general: {
      save_changes: `Αποθήκευση αλλαγών`,
      create_success: `Επιτυχής δημιουργία!`,
      update_success: `Επιτυχής επεξεργασία!`,
      something_wrong: `Κάτι πήγε στραβά!`,
    }
  },
  books: {
    title: `Βιβλια`,
    nav_title: `Βιβλία`,
    list: `Όλα τα βιβλία`,
    archived: `Αρχείο`,
    create: `Δημιουργία βιβλίου`,
  },
  videos: {
    title: `Οπτικο υλικο`,
    nav_title: `Βίντεο`,
    list: `Όλα τα βίντεο`,
    archived: `Αρχείο`,
    create: `Δημιουργία νέου`,
  },
  reports: {
    title: `Dashboard`,
    nav_title: `Στατιστικά`
  },
  categories: {
    title: `Κατηγοριες`,
    nav_title: `Κατηγορίες`,
    list: `Όλες οι κατηγορίες`,
    archived: `Αρχειοθετημένες κατηγορίες`,
    create: `Δημιουργία κατηγορίας`,
    create_title: `Δημιουργία νέας κατηγορίας`,
    new_category: `Νέα κατηγορία`,
    update_title: `Επεξεργασία κατηγορίας`,
    category: `Κατηγορία`,
    form: {
      name: `Όνομα κατηγορίας`,
      description: `Περιγραφή κατηγορίας`,
      isArchived: `Αρχειοθετημένη κατηγορία`,
      isPublished: `Ενεργή κατηγορία`,
      submit: `Δημιουργία κατηγορίας`
    }
  },
  roles: {
    super_admin: `Κύριος διαχειριστής`,
    simple_admin: `Διαχειριστής`,
  },
  settings: {
    title: `Ρυθμίσεις`,
    profile: `Προφίλ`,
    billing: `Χρεώσεις`,
  },
  vehicles: {
    title: `Ο Στόλος Μου`,
    nav_title: `Ο Στόλος Μου`,
    list: `Προβολή όλων`,
    archived: `Αρχειοθετημένα`,
    create: `Νέο Όχημα`,
    create_title: `Δημιουργία νέου Οχήματος`,
    new_vehicle: `Νέο Όχημα`,
    update_title: `Ενημέρωση Οχήματος`,
    vehicle: `Ηλεκτρικό Όχημα`,
    view_title: "Προβολή Οχήματος",
    tabs: {
      fleet: "Στόλος",
      operations: "Λειτουργίες",
      energy: "Ενέργεια",
      cost: "Κόστος",
      drivers: "Οδηγοί",
    },
    viewMode: {
      selectViewMode: "Επιλογή Τρόπου Προβολής",
      map: "Προβολή Χάρτη",
      mapDescription: "Οπτικοποιήστε τις τοποθεσίες του στόλου σας σε έναν διαδραστικό χάρτη για να παρακολουθείτε τις θέσεις τους σε πραγματικό χρόνο",
      table: "Προβολή Πίνακα",
      tableDescription: "Προβάλετε αναλυτικές πληροφορίες για τα οχήματά σας σε μορφή πίνακα για εύκολη ταξινόμηση και φιλτράρισμα",
    },
  },
  insights: {
    title: `Στατιστικά`,
    reports: `Αναφορές`,
  }
};

export default el;
